<div class="apollo-main history">
    <header>
      <h2>History</h2>
      <p>We keep track of your comparisons so you can review them at a later stage.</p>
    </header>


    <div class="instructions">
        <a (click)="howTo = !howTo" class="trigger" [ngClass]="{'opened' : howTo == true}"><em>How does this work?</em></a>
        <ol *ngIf="howTo">
          <li>Each comparison is recorded and <strong>time stamped</strong>.</li>
          <li>You can <strong>assign a name</strong> to the comparison by clicking on the title.</li>
          <li>You can <strong>access it</strong> with the link on the right.</li>
        </ol>
    </div>

    <div class="history-list">
      <ul>
          <li *ngFor="let item of history.items">
          <div>
            <a [routerLink]="[]"  (click)="goToUpload(item.hash)" class="li_mob">Access comparison</a>
            <!-- <input type="text" (focus)="this.value=item.name==null? '': item.name" (focusout)="setName(item.hash, this.value)" value="{{item.name==null?'hola' : item.name}}"  /> -->
            <input type="text" (keydown.enter)="setName(item.hash, item.name)" (focusout)="setName(item.hash, item.name)" [(ngModel)]="item.name" [ngModelOptions]="{standalone: true}" placeholder="Comparison for files loaded on {{item.date | date:'MMMM dd yyyy, HH:mm'}}"/>
            <p>{{item.date | date:'MMMM dd, yyyy, HH:mm'}} <!-- 22 November 2018 at 13:34 --></p>
            <a [routerLink]="[]"  (click)="goToUpload(item.hash)" class="li_dk">Access comparison</a>
          </div>
          </li>
          <!-- <li>
            <div>
            <a class="li_mob">Access comparison</a>
            <input type="text" onfocus="this.value=''" value="Comparison for files loaded on 26th November 2018" />
            <p>23 November 2018 at 13:34</p>
            <a class="li_dk" >Access comparison</a>
            </div>
          </li> --->
        </ul>
        <p *ngIf="history.items.length==0 && history.last">No comparisons saved</p>
        <core-helpers-box-loading [hidden]="!loading"></core-helpers-box-loading>
    </div>
    <div class="history-load-more-button">
        <div class="btn-center">
            <core-helpers-forms-button-white [hidden]="page==0 || history.last" [text]="'Load more'" (submit)="loadMore()"></core-helpers-forms-button-white>
        </div>
    </div>

</div>
